<div style="display: block; width: 350px">
    <canvas id="piecanvas">{{ chart }}</canvas>
</div>

<div class="custom-table-list-row-main" *ngIf="isPieChartLoder">
    <div class="custom-col-width-100 text-danger d-flex justify-content-center">
        <app-common-icon [loadingIcon]="true"></app-common-icon>
    </div>
</div>

<div class="color-red error-message" *ngIf="(!data || data.length === 0) && !isPieChartLoder">
    <p>There are currently No files/documents</p>
</div>



